import { render, staticRenderFns } from "./firmakarticomp.vue?vue&type=template&id=54cc8b0b"
import script from "./firmakarticomp.vue?vue&type=script&lang=js"
export * from "./firmakarticomp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports